import { render, staticRenderFns } from "./about-brief-in-index.vue?vue&type=template&id=5b3fa2fa&"
import script from "./about-brief-in-index.vue?vue&type=script&lang=js&"
export * from "./about-brief-in-index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports